<!--  广告设置 -->
 
<template>
  <div class="content">
    <div class="header">

      <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left">

        <el-row style="margin: 10px  0 10px">
          <el-form-item label="">
            <el-input v-model.trim="formTool.name" placeholder="请输入广告位名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formTool.platform" clearable style="width: 160px;" size="small" placeholder="请选择平台端">
              <el-option v-for="item in sourceTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formTool.layout" clearable style="width: 160px;" size="small" placeholder="请选择展示方向">
              <el-option v-for="item in showOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formTool.status" clearable style="width: 120px;" size="small" placeholder="请选择状态">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="addBanner">新增广告位置</el-button>
          </el-form-item>
        </el-row>

      </el-form>
    </div>

    <div class="center" style="position: relative">
      <MyTable :table-data="tableData" :index="index" :selection="selection" :page="page" :operation="operation" 
        :table-option.sync="tableOption" @page-change="getList" @handleSelectionChange="handleSelectionChange">
        <template slot="menu" slot-scope="scope">
          <el-link :underline="false" type="primary" @click="changeStatusHandle(scope.row, '启用')"
          v-if="scope.row.status =='0' "
            class="btn-list">启用</el-link>
          <el-link :underline="false" type="primary" @click="changeStatusHandle(scope.row, '停用')"
          v-if="scope.row.status =='1' "
            class="btn-list">停用</el-link>
          <el-link :underline="false" type="primary" @click="detailHandle(scope.row, '详情')" class="btn-list">详情</el-link>
          <el-link :underline="false" type="primary" @click="detailHandle(scope.row, '编辑')" class="btn-list"   v-if="scope.row.status =='0' ">编辑</el-link>
          <el-link :underline="false" type="primary" @click="changeStatusHandle(scope.row, '删除')"  v-if="scope.row.status =='0' "
            class="btn-list">删除</el-link>
        </template>
        <!-- picPx -->
        <template slot="picPx" slot-scope="scope">
          {{ scope.row.width }}
          *
          {{ scope.row.height }}
        </template>

        <template slot="layout" slot-scope="scope">
          {{ scope.row.layout | filterLayout }}
        </template>
        <template slot="platform" slot-scope="scope">
          {{ scope.row.platform | filterPlatName }}
        </template>
        <template slot="status" slot-scope="scope">
          <!-- <span style="color:#E6A23C" v-if="scope.row.checkStatus == 0"><i class="el-icon-warning"></i> 启用</span> -->
          <span style="color:#67C23A" v-if="scope.row.status === '1'"><i class="el-icon-success"></i> 启用</span>
          <span style="color:#F5222d" v-if="scope.row.status === '0'"><i class="el-icon-warning"></i> 停用</span>
        </template>
        <template slot="positionDescription" slot-scope="scope">
          <div style="display:column;align-items:center;justify-content: left;">
            <div class="imageP" style="width:100%;display:flex;align-items:left;justify-content: left;">
              <p>
                {{ scope.row.positionDescription }}
              </p>
            </div>
            <div style="width:100%;height:100%px;display:flex;align-items:center;justify-content:left;">
              <el-image style="width:80px;" :src="scope.row.previewImage || avater"
                :preview-src-list="[scope.row.previewImage || avater]" lazy />
            </div>
          </div>
        </template>
      </MyTable>
      
    </div>

    <addDialog ref="add-dialog" @getList="getList" />

  </div>
</template>

<script>
const sourceTypeOptions = [
  {
    value: 'MERCHANT_PC',
    label: '商户端(PC)'
  },
  {
    value: 'MERCHANT_APP',
    label: '商户端(APP)'
  },
  {
    value: 'CLIENT_PC',
    label: '客户端(PC)'
  },
  {
    value: 'CLIENT_APP',
    label: '客户端(APP)'
  },
  {
    value: 'CLIENT_MINI',
    label: '客户端(小程序)'
  },
  {
    value: 'BUSINESS_PC',
    label: '业务端PC'
  },
  {
    value: 'BUSINESS_APP',
    label: '业务端(APP)'
  },
];
const showOptions = [
  {
    value: 0,
    label: '横向'
  },
  {
    value: 1,
    label: '纵向'
  },
]
import MyTable from "@/components/myTable";
import addDialog from "./components/addPosition.vue";
import { positionSettingGetPage, positionSettingDelete, positionSettingEnable } from "@/api/bannerManage";
import avater from "/public/img/default.png";
export default {
  components: { MyTable, addDialog },
  data() {
    return {
      activeName: 'first',
      avater: avater,
      formTool: {
      },
      btnType: 'add',
      selectionList: [],
      operation: true,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [
        { label: "广告位名称", prop: "name" },
        { label: "位置描述", prop: "positionDescription", slot: true },
        { label: "所属平台", prop: "platform", slot: true },
        { label: "图片尺寸（像素）", prop: "picPx", slot: true },
        { label: "图片展示方向", prop: "layout", slot: true },
        { label: "图片数量", prop: "maxImageNum" },
        { label: "状态", prop: "status", slot: true },
        { label: "更新人", prop: "updateBy" },
        { label: "更新时间", prop: "updateTime" },
      ],
      showOptions: showOptions,
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      sourceTypeOptions: sourceTypeOptions,
      statusOptions: [
        
        {
          value: '1',
          label: '启用'
        },
        {
          value: '0',
          label: '停用'
        },
      ],
      dialogShow: false
    };
  },
  computed: {},
  filters: {
    filterPlatName(e) {
      for (let i = 0; i < sourceTypeOptions.length; i++) {
        if (e == sourceTypeOptions[i].value) return sourceTypeOptions[i].label
      }
    },
    filterLayout(e) {
      for (let i = 0; i < showOptions.length; i++) {
        if (e == showOptions[i].value) return showOptions[i].label
      }
    },
  },
  watch: {},
  created() {
    this.getList();
  },
  mounted() { },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  computed: {

  },
  methods: {

    // 页码变化
    handleCurrentChange(e) {
      this.page.current = e
    },
    // 条数变化
    handleSizeChange(e) {
      this.page.size = e
      this.page.current = 1
    },
    changeStatusHandle(row, btnType) {
      this.$confirm(`确定要${btnType}【${row.name}】吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {};
          params.id = row.id;
          if (btnType == '启用') {
            params.status = '1';
          }
          if (btnType == '停用') {
            params.status = '0';
          }
          if (btnType == '删除') {
            positionSettingDelete(row.id).then((res) => {
              if (res) this.$message.success('操作成功')
              this.getList()
            }).catch((err) => { })
          } else {
            positionSettingEnable(params).then((res) => {
              if (res) this.$message.success('操作成功')
              this.getList()
            }).catch((err) => { })
          }
        })
        .catch(() => { });
    },

    detailHandle(row, btnType) {
      if (btnType == '编辑') {
        this.$refs['add-dialog'].init(row, 'edit')
      }
      if (btnType == '详情') {
        this.$refs['add-dialog'].init(row, 'detail')
      }
    },

    addBanner(row, btnType) {
      this.$refs['add-dialog'].init()
    },

    // 重置查询条件
    reset() {
      this.formTool = {};
      this.getList(1);
    },
    // 搜索
    getList(current) {
      this.positionSettingGetPage(current);
    },
    // 勾选
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 查询 
    positionSettingGetPage(current) {
      if (current) {
        this.page.current = current;
      }
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size
      };

      positionSettingGetPage(params).then((res) => {
        if (res) {
          this.tableData = res.records;
          this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped> 
.content {
    height: calc(100% - 120px);

    .header {
      width: 100%;
      margin: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding: 0px 24px 0px 24px !important;
      border-bottom: 1px solid #f5f5f5;

      .font {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: left;
        color: #262626;
      }

      .el-form-item {
        margin: 0px 0px 0px 8px !important;
      }
    }

    .center {
      margin-top: 16px;
      padding: 0 24px;
      height: calc(100% - 0px);
     

      .shangjia {
        position: absolute;
        z-index: 2;
        bottom: -45px;
      }
    }

    .btn-warp {
      display: flex;
      justify-content: space-around;

    }
  }

  .btn-list {
    margin: 0 10px;
  }
  ::v-deep .el-table{
    height: calc(100% - 120px)!important;
   overflow: auto;
  }
</style>
